import Container from '../../common/Container';
import Header from '../../common/Header';
import Collections from '../../components/staking/Collections';
import RpcDropdown from '../../components/staking/RpcDropdown';

const Staking = () => {
  return (
    <Container>
      <Header />
      <Collections />
      <RpcDropdown />
    </Container>
  );
};

export default Staking;
